import { render, staticRenderFns } from "./files.vue?vue&type=template&id=0a12ebcc&scoped=true"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"
import style0 from "./files.vue?vue&type=style&index=0&id=0a12ebcc&prod&lang=scss&scoped=true"
import style1 from "./files.vue?vue&type=style&index=1&id=0a12ebcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12ebcc",
  null
  
)

export default component.exports